import { motion } from 'framer-motion'
import type { AnalyticsData } from './types'

interface UserAgentPanelProps {
  analyticsData: AnalyticsData
}

export default function UserAgentPanel({ analyticsData }: UserAgentPanelProps) {
  return (
    <>
      {/* User Agent 분석 */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 1.3 }}
        className="mb-8 rounded-lg bg-white shadow dark:bg-gray-800"
      >
        <div className="px-4 py-5 sm:p-6">
          <h3 className="mb-4 text-lg font-medium leading-6 text-gray-900 dark:text-white">
            User Agent 분석
          </h3>
          <div className="overflow-hidden">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
              <thead className="bg-gray-50 dark:bg-gray-700">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300">
                    User Agent
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300">
                    클릭수
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300">
                    고유 IP
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white dark:divide-gray-700 dark:bg-gray-800">
                {analyticsData.userAgentStats
                  ?.slice(0, 10)
                  .map((userAgent, index) => (
                    <tr
                      key={index}
                      className={
                        index % 2 === 0
                          ? 'bg-white dark:bg-gray-800'
                          : 'bg-gray-50 dark:bg-gray-700'
                      }
                    >
                      <td className="px-4 py-4">
                        <div className="break-all font-mono text-xs text-gray-900 dark:text-white">
                          {userAgent.shortUserAgent}
                        </div>
                      </td>
                      <td className="whitespace-nowrap px-4 py-4">
                        <div className="text-sm text-gray-900 dark:text-white">
                          {userAgent.count.toLocaleString()}
                        </div>
                      </td>
                      <td className="whitespace-nowrap px-4 py-4">
                        <div className="text-sm text-gray-900 dark:text-white">
                          {userAgent.uniqueIps.toLocaleString()}
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </motion.div>
    </>
  )
}
